import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const refresh: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11.813-3.75q-.002.036-.016.047c-.336 1.398-1.031 2.531-2.094 3.406Q8.11 1 5.97 1A5.8 5.8 0 0 1 3.766.563a5.9 5.9 0 0 1-1.907-1.22L.86.36A.53.53 0 0 1 .5.5.5.5 0 0 1 .14.344.47.47 0 0 1 0 0v-3.5q0-.201.14-.344A.5.5 0 0 1 .5-4H4c.133 0 .25.055.344.156.101.094.156.211.156.344q0 .204-.14.344L3.28-2.078q.562.516 1.266.797Q5.25-1.001 6-1c.695 0 1.348-.164 1.953-.5a4.04 4.04 0 0 0 1.453-1.406q.094-.14.422-.922.059-.17.235-.172h1.5q.091 0 .171.078.078.066.079.172M12-10v3.5a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14H8a.52.52 0 0 1-.36-.14.52.52 0 0 1-.14-.36q-.001-.2.156-.36l1.078-1.077A3.92 3.92 0 0 0 6-9q-1.05 0-1.953.516a3.9 3.9 0 0 0-1.453 1.39q-.08.128-.406.907Q2.123-6 1.953-6H.391a.23.23 0 0 1-.172-.078.23.23 0 0 1-.078-.172v-.062Q.656-8.404 2.25-9.703 3.855-11 6-11q1.139.002 2.219.438 1.079.42 1.922 1.218l1.015-1.015a.47.47 0 0 1 .344-.141c.133 0 .25.055.344.156.101.094.156.211.156.344m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
